import CheckCircleUncheckedIcon from '@atlaskit/icon/core/check-circle-unchecked';
import * as React from 'react';

export function SvgCheckCircleUnchecked() {
  return <CheckCircleUncheckedIcon label="" testId="ads-refreshed-icon" />;
}
